import React from 'react';
import { Box } from './Box';

export const SplitLine = () => (
  <Box mt="16" mb="16" style={{ width: '100%' }}>
    <div style={{ height: 1, width: '100%', backgroundColor: 'rgba(141,141,141, 0.2)' }} />
  </Box>
);
